<template>
  <div class="occupancy-by-room-banner">
    <div class="occupancy-by-room-banner__content">
      <i class="icon sm rhg-font-icon--user"></i>
      <span class="occupancy-by-room-banner__text" v-html="occupancyByRoomLabel"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OccupancyByRoomBanner',
  components: {},
  props: {
    currentRoom: {
      type: Number
    },
    occupancyByRooms: {
      type: Array
    }
  },

  computed: {
    currentRoomData() {
      return this.occupancyByRooms && this.occupancyByRooms[this.currentRoom - 1]
    },
    nAdults() {
      return this.currentRoomData.adults
    },
    nChildren() {
      return this.currentRoomData.children.length
    },
    occupancyByRoomLabel() {
      const adultsLabel = `<span class="font-bold">${this.translate('rdNumAdults', this.nAdults, this.nAdults)}</span>`
      const childrenLabel = `<span class="font-bold">${this.translate('rdNumChildren', this.nChildren, this.nChildren)}</span>`
      const roomLabel = this.translate(
        'rdThisRoomIsFor',
        `${adultsLabel}, ${childrenLabel}`,
        `${adultsLabel}, ${childrenLabel}`
      )
      return `${roomLabel}`
    }
  }
}
</script>

<style lang="scss" scoped>
.occupancy-by-room-banner {
  display: flex;
  min-width: 310px;
  padding-inline-end: 0.75rem;
  &__content {
    display: flex;
    align-items: center;
    background-color: #f6f6f6;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #d8d8d8;
    width: 100%;

    @media (max-width: 992px) {
      margin: 0 1rem 1.6rem;
      width: 100%;
      max-width: none;
    }
  }

  &__text {
    padding-inline: 8px;
    font-size: 14px;
  }
}
</style>
